import service from '../service/direct_sales'
import CONSTANT from '../constant/direct_sales'
import _ from 'underscore'
export default {
    getDirectSalesMenus ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getDirectSalesMenus(data).then(result => {
                resolve(result)
                commit(CONSTANT.DIRECT_SALES_GETDIRECTSALESMENUS_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.DIRECT_SALES_GETDIRECTSALESMENUS_ERROR, e)
            })
        })
    },
    getDirectSalesRecommend ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getDirectSalesRecommend(data).then(result => {
                resolve(result)
                commit(CONSTANT.DIRECT_SALES_GETDIRECTSALESRECOMMEND_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.DIRECT_SALES_GETDIRECTSALESRECOMMEND_ERROR, e)
            })
        })
    },
    /*yeoman-template-point-1*/
}